export const getDiscountPresentage = (original_price, special_price) => {
  if (original_price <= special_price) return false;
  // 3. Calculate the discount percentage by subtracting the special price from
  //    the original price and dividing the result by the original price
  let discount = ((original_price - special_price) / original_price) * 100;

  // Return the discount as a rounded up to two decimal places string value
  return Number(discount) ? Math.floor(discount) : false;
};

export function validateDiscountPrice(item) {
  const prices = item?.prices_with_tax;
  if (prices?.price == prices?.discouted_price) return false;
}
